import { MdsConfig } from "@maersk-global/mds-config";
MdsConfig.iconsDynamicImportPath = "./assets/styles/design_system/";

import './main-app.js';
